module.exports = __webpack_public_path__ + "img/architectural-elements-1.d52f4b1f.jpeg";